<section style="margin-top: 2rem;">
  <h2>Soci</h2>
  <div class="scrollable-table-container">
    <table mat-table [dataSource]="personaGiuridica?.extension?.['shareholders'] || []"
      class="table table-primary-color">

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef> Tipologia </th>
        <td mat-cell *matCellDef="let element"> {{element.type}} </td>
      </ng-container>

      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef> Paese </th>
        <td mat-cell *matCellDef="let element"> {{element.country}} </td>
      </ng-container>

      <ng-container matColumnDef="share">
        <th mat-header-cell *matHeaderCellDef>Quota partecipativa</th>
        <td mat-cell *matCellDef="let element"> {{element.share | currency:'%':'symbol':'1.2-2':'it'}} </td>
      </ng-container>


      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element; let i = index">
          <button *ngIf="!praticaProgressService.isFrozenOrConfermata" mat-icon-button class="icon-button"
            aria-label="Modifica elemento" matTooltip="Modifica elemento" (click)="openShareholderDialog(element, i)">
            <mat-icon svgIcon="edit"></mat-icon>
          </button>
          <button *ngIf="!praticaProgressService.isFrozenOrConfermata" mat-icon-button class="icon-button"
            aria-label="Elimina elemento" matTooltip="Elimina elemento" (click)="deleteShareholder(element)">
            <mat-icon svgIcon="delete"></mat-icon>
          </button>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" style="text-align: center; padding: 20px 0;" colspan="7">Nessun elemento presente al
          momento.
        </td>
      </tr>
    </table>
  </div>

  <div class="margin-top-rounded-buttons">
    <button mat-flat-button color="accent" class="squared-button" aria-label="Aggiungi nuovo soggetto"
      [disabled]="praticaProgressService.isFrozenOrConfermata" matTooltip="Aggiungi nuovo soggetto"
      (click)="openShareholderDialog()">
      +
    </button>
  </div>

</section>